import { useController, useForm } from 'react-hook-form';
import { useLanguage } from '../locale';
import { emailValidation } from '../utils/regex';
export var useAuthenticationForm = function () {
    var _a;
    var t = useLanguage()[0];
    var _b = useForm(), control = _b.control, handleSubmit = _b.handleSubmit, setValue = _b.setValue, errors = _b.formState.errors;
    var emailController = useController({
        name: 'email',
        control: control,
        rules: {
            required: {
                value: true,
                message: t('emailCheckScreen.emailRequiredError'),
            },
            pattern: {
                value: emailValidation,
                message: t('emailCheckScreen.emailFormatError'),
            },
        },
    });
    var onEmailChange = function (e) {
        var trimmedValue = typeof e === 'string' ? e.trim() : e.target.value.trim();
        emailController.field.onChange(trimmedValue === null || trimmedValue === void 0 ? void 0 : trimmedValue.toLowerCase());
    };
    return {
        onEmailChange: onEmailChange,
        emailValue: (_a = emailController.field.value) === null || _a === void 0 ? void 0 : _a.trim(),
        handleSubmit: handleSubmit,
        errors: errors,
        setValue: setValue,
    };
};
